const get_user = (user) => {
    return async dispatch => {
        await dispatch ({ type: "SET_USER" , payload: user})
    }
}

export {
    get_user
}